import React, { useState, useRef } from 'react';
import emailjs from 'emailjs-com';

const ContactUs = () => {
  const form = useRef();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [error, setError] = useState(''); // State for email validation

  const sendEmail = (e) => {
    e.preventDefault();

    // Get form values
    const email = form.current.user_email.value.trim();
    
    // Validate email field
    if (!email) {
      setError('Email is required.');
      return;
    }

    setError(''); // Clear previous errors

    emailjs
      .sendForm('service_ycxsn0x', 'template_dc6l1qa', form.current, 'i3MXGDw2ZQHNdgw3y')
      .then(
        (result) => {
          console.log(result.text);
          setModalMessage('Message sent successfully!');
          setShowModal(true);
          clearForm();
        },
        (error) => {
          console.log(error.text);
          setModalMessage('Failed to send message.');
          setShowModal(true);
        }
      );
  };

  const clearForm = () => {
    form.current.reset();
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <section id="contact-us" className="w-full min-h-screen bg-white flex justify-center items-center px-8 lg:px-20 py-12">
      <div className="container mx-auto flex flex-col justify-center items-center">
        
        {/* Title and Subtitle */}
        <div className="text-center mb-5">
          <h2 className="text-lg font-semibold text-gray-500 uppercase tracking-wider">Contact Us</h2>
          <h1 className="text-4xl font-semibold text-[#30779b] mt-3">Get in Touch</h1>
          <p className="text-base text-gray-600 mt-2">
            Got any inquiries or need support? Let us know how we can help.
          </p>
        </div>

        {/* Contact Form */}
        <div className="w-full lg:w-1/2 bg-gray-100 p-8 rounded-xl shadow-lg">
          <form ref={form} onSubmit={sendEmail} className="space-y-6">
            <div className="flex flex-col space-y-2">
              <label className="text-sm text-gray-700" htmlFor="name">Name</label>
              <input
                type="text"
                name="user_name"
                placeholder="Your Name"
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
            </div>
            <div className="flex flex-col space-y-2">
              <label className="text-sm text-gray-700" htmlFor="email">Email <span className="text-red-500">*</span></label>
              <input
                type="email"
                name="user_email"
                placeholder="Your Email"
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              {error && <p className="text-red-500 text-sm">{error}</p>} {/* Show error if email is missing */}
            </div>
            <div className="flex flex-col space-y-2">
              <label className="text-sm text-gray-700" htmlFor="message">Message</label>
              <textarea
                name="message"
                placeholder="What would you like to know more about?"
                className="w-full p-3 border border-gray-300 rounded-lg h-32 resize-none"
              />
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500 mb-5 text-center">
                <strong>Email Privacy Disclaimer:</strong> We respect your privacy. Your email address will be kept confidential and will not be shared, sold, or used for spam. UDC will never send you unsolicited emails or share your email with third-party marketers. <br/>It will only be used for the intended purpose of communication.
              </p>
              
              <button
                type="submit"
                className="bg-[#30779b] text-white py-2 px-8 rounded-full hover:bg-[#233F51] transition"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg shadow-lg w-[300px] text-center">
            <div className="flex justify-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-12 w-12 text-green-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2l4-4m-7 8a9 9 0 11.001-18.001A9 9 0 0112 21z"
                />
              </svg>
            </div>
            <h2 className="text-xl font-bold mb-2">Success!</h2>
            <p className="text-gray-600">{modalMessage}</p>
            <button
              onClick={closeModal}
              className="bg-blue-500 text-white py-2 px-6 rounded-full mt-4 hover:bg-blue-600 transition"
            >
              Okay
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ContactUs;
